import { HttpApiSchema } from "@effect/platform";
import { Effect, Predicate, Schema } from "effect";
import * as CurrentUser from "./CurrentUser";
export const ErrorBaseSchema = Schema.Struct({
    type: Schema.URL,
    title: Schema.String.pipe(Schema.maxLength(128)),
    detail: Schema.String.pipe(Schema.maxLength(255))
});
export class NotFound extends Schema.TaggedError()("@superwall/schema/models/errors/NotFound", {
    entityType: Schema.String,
    entityId: Schema.NullOr(Schema.Union(Schema.String, Schema.Number))
}, HttpApiSchema.annotations({
    status: 404,
    title: "NotFound"
})) {
    get message() {
        if (this.entityId) {
            return `${this.entityType} with identifier ${this.entityId} not found`;
        }
        return `${this.entityType} not found`;
    }
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/NotFound");
    }
}
export class InternalServerError extends Schema.TaggedError()("@superwall/schema/models/errors/InternalServerError", {
    ...ErrorBaseSchema.fields,
    cause: Schema.Defect,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>new URL("https://superwall.com/errors/internal-server-error")
    })
}, HttpApiSchema.annotations({
    status: 500,
    title: "InternalServerError",
    description: "An unexpected error occurred"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/InternalServerError");
    }
}
export class Unauthorized extends Schema.TaggedError()("@superwall/schema/models/errors/Unauthorized", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>new URL("https://superwall.com/errors/unauthorized")
    })
}, HttpApiSchema.annotations({
    status: 401,
    title: "Unauthorized"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/Unauthorized");
    }
    static refail(entity, action) {
        return (effect)=>Effect.catchIf(effect, (e)=>!Unauthorized.is(e), ()=>Effect.flatMap(CurrentUser.Context, (actor)=>new Unauthorized({
                        title: `Unauthorized action`,
                        detail: `You are not authorized to perform ${action} on ${entity} for ${actor.userId}`
                    })));
    }
}
export class BadRequest extends Schema.TaggedError()("@superwall/schema/models/errors/BadRequest", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>new URL("https://superwall.com/errors/bad-request")
    })
}, HttpApiSchema.annotations({
    status: 400,
    title: "BadRequest",
    description: "The request was invalid"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/BadRequest");
    }
}
export class ConflictError extends Schema.TaggedError()("@superwall/schema/models/errors/ConflictError", {
    ...ErrorBaseSchema.fields,
    type: Schema.optionalWith(ErrorBaseSchema.fields.type, {
        default: ()=>new URL("https://superwall.com/errors/Conflict")
    })
}, HttpApiSchema.annotations({
    status: 409,
    title: "ConflictError"
})) {
    static is(u) {
        return Predicate.isTagged(u, "@superwall/schema/models/errors/ConflictError");
    }
}
